import type { Card } from "./types";

export const PHRASES: Card[] = [
  {
    "id": "sm-day",
    "kind": "phrase",
    "lang": "en",
    "text": "How's your day going?",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You're waiting for a meeting to start with a colleague you don't know well.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sm-seen",
    "kind": "phrase",
    "lang": "en",
    "text": "Long time no see!",
    "phonemes": [],
    "category": "smalltalk",
    "register": "idiom",
    "scenario": "You run into an old friend on the street.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I haven't seen you in a while."
  },
  {
    "id": "sm-upto",
    "kind": "phrase",
    "lang": "en",
    "text": "What have you been up to lately?",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You're catching up with someone after a few months apart.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sm-world",
    "kind": "phrase",
    "lang": "en",
    "text": "Small world!",
    "phonemes": [],
    "category": "smalltalk",
    "register": "idiom",
    "scenario": "You discover you both know the same person, out of nowhere.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "What a surprising coincidence."
  },
  {
    "id": "sm-know",
    "kind": "phrase",
    "lang": "en",
    "text": "So, how do you two know each other?",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You're introduced to someone at a party alongside a mutual friend.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sm-weather",
    "kind": "phrase",
    "lang": "en",
    "text": "Crazy weather we're having, huh?",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You're making small talk while waiting in line.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sm-place",
    "kind": "phrase",
    "lang": "en",
    "text": "I love what you've done with the place.",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You walk into a friend's newly decorated home.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sm-ice",
    "kind": "phrase",
    "lang": "en",
    "text": "Let's break the ice.",
    "phonemes": [],
    "category": "smalltalk",
    "register": "idiom",
    "scenario": "You're the host and the room's gone quiet.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Let's ease the awkwardness and start talking."
  },
  {
    "id": "ag-more",
    "kind": "phrase",
    "lang": "en",
    "text": "I couldn't agree more.",
    "phonemes": [],
    "category": "agree",
    "register": "connector",
    "scenario": "A colleague states an opinion you fully share.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "ag-nail",
    "kind": "phrase",
    "lang": "en",
    "text": "You hit the nail on the head.",
    "phonemes": [],
    "category": "agree",
    "register": "idiom",
    "scenario": "Someone just summarized the problem perfectly.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "You're exactly right."
  },
  {
    "id": "ag-thinking",
    "kind": "phrase",
    "lang": "en",
    "text": "That's exactly what I was thinking.",
    "phonemes": [],
    "category": "agree",
    "register": "connector",
    "scenario": "Someone voices the same idea you had in mind.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "ag-noquestion",
    "kind": "phrase",
    "lang": "en",
    "text": "Absolutely, no question.",
    "phonemes": [],
    "category": "agree",
    "register": "connector",
    "scenario": "You're asked to confirm you're on board with a plan.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "ag-mind",
    "kind": "phrase",
    "lang": "en",
    "text": "You read my mind.",
    "phonemes": [],
    "category": "agree",
    "register": "idiom",
    "scenario": "A friend suggests the exact plan you were about to propose.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "You said exactly what I was about to say."
  },
  {
    "id": "ag-withyou",
    "kind": "phrase",
    "lang": "en",
    "text": "I'm totally with you on that.",
    "phonemes": [],
    "category": "agree",
    "register": "connector",
    "scenario": "A friend shares a strong opinion and you want to back them up.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "ag-page",
    "kind": "phrase",
    "lang": "en",
    "text": "Sounds like we're on the same page.",
    "phonemes": [],
    "category": "agree",
    "register": "idiom",
    "scenario": "You want to confirm alignment before a project kicks off.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "We understand and agree with each other."
  },
  {
    "id": "ag-argue",
    "kind": "phrase",
    "lang": "en",
    "text": "Can't argue with that.",
    "phonemes": [],
    "category": "agree",
    "register": "idiom",
    "scenario": "Someone makes a logical point that settles the debate.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "That's a fair point I can't dispute."
  },
  {
    "id": "dis-differently",
    "kind": "phrase",
    "lang": "en",
    "text": "I see it a bit differently.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "You want to push back on a colleague's proposal without shutting it down.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "dis-notsure",
    "kind": "phrase",
    "lang": "en",
    "text": "I'm not so sure about that.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "Someone states something confidently that you doubt.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "dis-respect",
    "kind": "phrase",
    "lang": "en",
    "text": "With respect, I think there's another way to look at this.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "You disagree with someone more senior in a meeting.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "dis-fairbut",
    "kind": "phrase",
    "lang": "en",
    "text": "That's a fair point, but…",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "You want to acknowledge someone's argument before disagreeing.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "dis-pushback",
    "kind": "phrase",
    "lang": "en",
    "text": "I hear what you're saying, though I'd push back a little.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "A friend makes a claim you want to gently challenge.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "dis-agreedisagree",
    "kind": "phrase",
    "lang": "en",
    "text": "Let's agree to disagree.",
    "phonemes": [],
    "category": "disagree",
    "register": "idiom",
    "scenario": "A debate has gone in circles and isn't resolving.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "We won't reach the same conclusion, and that's okay."
  },
  {
    "id": "dis-leaning",
    "kind": "phrase",
    "lang": "en",
    "text": "I take your point, but I'm leaning the other way.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "You want to concede part of an argument while holding your position.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "dis-devil",
    "kind": "phrase",
    "lang": "en",
    "text": "Playing devil's advocate for a second…",
    "phonemes": [],
    "category": "disagree",
    "register": "idiom",
    "scenario": "You want to challenge the group's consensus constructively.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Arguing the opposite side just to test the idea."
  },
  {
    "id": "sof-honest",
    "kind": "phrase",
    "lang": "en",
    "text": "To be honest, I think…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "A friend asks what you really think of their plan.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sof-notthing",
    "kind": "phrase",
    "lang": "en",
    "text": "If I'm honest, it's not really my thing.",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "Someone asks if you liked a gift or gesture you didn't love.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sof-wrong",
    "kind": "phrase",
    "lang": "en",
    "text": "I could be wrong, but…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "You want to offer a correction without sounding certain or harsh.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sof-salt",
    "kind": "phrase",
    "lang": "en",
    "text": "Take this with a grain of salt, but…",
    "phonemes": [],
    "category": "soften",
    "register": "idiom",
    "scenario": "You're sharing a rumor or an unverified opinion.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Don't fully rely on what I'm about to say."
  },
  {
    "id": "sof-noffense",
    "kind": "phrase",
    "lang": "en",
    "text": "No offense, but…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "You're about to say something that could sound critical.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sof-twocents",
    "kind": "phrase",
    "lang": "en",
    "text": "It's just my two cents.",
    "phonemes": [],
    "category": "soften",
    "register": "idiom",
    "scenario": "You've given advice and want to lower the stakes of it.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "This is only my personal, modest opinion."
  },
  {
    "id": "sof-offbase",
    "kind": "phrase",
    "lang": "en",
    "text": "I might be off base here, but…",
    "phonemes": [],
    "category": "soften",
    "register": "idiom",
    "scenario": "You're raising a concern you're not fully confident about.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I might be mistaken about this."
  },
  {
    "id": "sof-correct",
    "kind": "phrase",
    "lang": "en",
    "text": "Correct me if I'm wrong…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "You want to state something while inviting pushback.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "re-rough",
    "kind": "phrase",
    "lang": "en",
    "text": "That's rough, I'm sorry.",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "A friend tells you about a bad day at work.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "re-noway",
    "kind": "phrase",
    "lang": "en",
    "text": "No way!",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "Someone shares surprising or shocking news.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "re-imagine",
    "kind": "phrase",
    "lang": "en",
    "text": "I can only imagine how that feels.",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "A friend describes a difficult, unfamiliar situation.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "re-tough",
    "kind": "phrase",
    "lang": "en",
    "text": "That must have been tough.",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "Someone recounts a stressful experience.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "re-happy",
    "kind": "phrase",
    "lang": "en",
    "text": "I'm so happy for you!",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "A friend shares great news, like a promotion.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "re-kidding",
    "kind": "phrase",
    "lang": "en",
    "text": "You're kidding me!",
    "phonemes": [],
    "category": "react",
    "register": "idiom",
    "scenario": "Someone tells you something hard to believe.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Expresses surprise or disbelief."
  },
  {
    "id": "re-sense",
    "kind": "phrase",
    "lang": "en",
    "text": "That makes total sense.",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "Someone explains their reasoning and you want to validate it.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "re-heart",
    "kind": "phrase",
    "lang": "en",
    "text": "My heart goes out to you.",
    "phonemes": [],
    "category": "react",
    "register": "idiom",
    "scenario": "A friend shares sad or difficult news.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I feel deep sympathy for you."
  },
  {
    "id": "cl-again",
    "kind": "phrase",
    "lang": "en",
    "text": "Sorry, could you say that again?",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You missed part of what someone said.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "cl-right",
    "kind": "phrase",
    "lang": "en",
    "text": "Let me make sure I've got this right…",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You want to repeat back what you understood before responding.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "cl-meanby",
    "kind": "phrase",
    "lang": "en",
    "text": "What do you mean by that, exactly?",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "Someone uses a term or phrase you're not sure you understood.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "cl-second",
    "kind": "phrase",
    "lang": "en",
    "text": "Give me a second to think about that.",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You're asked a question and need a moment before answering.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "cl-getback",
    "kind": "phrase",
    "lang": "en",
    "text": "Let me get back to you on that.",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You don't have an answer ready and need time.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "cl-goodq",
    "kind": "phrase",
    "lang": "en",
    "text": "That's a good question — let me think.",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You're asked something unexpected in a meeting.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "cl-saying",
    "kind": "phrase",
    "lang": "en",
    "text": "So what you're saying is…",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You want to paraphrase someone's point to confirm you understood.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "cl-blank",
    "kind": "phrase",
    "lang": "en",
    "text": "I'm drawing a blank right now.",
    "phonemes": [],
    "category": "clarify",
    "register": "idiom",
    "scenario": "You're asked something and momentarily can't recall the answer.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I can't remember or think of it right now."
  },
  {
    "id": "tr-movingon",
    "kind": "phrase",
    "lang": "en",
    "text": "Anyway, moving on…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to shift the conversation to a new topic.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "tr-reminds",
    "kind": "phrase",
    "lang": "en",
    "text": "That reminds me…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "Something just said sparked a related thought.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "tr-differentnote",
    "kind": "phrase",
    "lang": "en",
    "text": "On a different note…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to bring up something unrelated to what was just discussed.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "tr-speaking",
    "kind": "phrase",
    "lang": "en",
    "text": "Speaking of which…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to connect the next topic to what was just mentioned.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "tr-forget",
    "kind": "phrase",
    "lang": "en",
    "text": "Before I forget…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You remember something you need to say before it slips your mind.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "tr-subject",
    "kind": "phrase",
    "lang": "en",
    "text": "While we're on the subject…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to add something related to the current topic.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "tr-earlier",
    "kind": "phrase",
    "lang": "en",
    "text": "Getting back to what you said earlier…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to return to an earlier point in the conversation.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "tr-circleback",
    "kind": "phrase",
    "lang": "en",
    "text": "Let's circle back to that.",
    "phonemes": [],
    "category": "transition",
    "register": "idiom",
    "scenario": "A tangent comes up mid-discussion and you want to note it for later.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Let's return to that topic later."
  },
  {
    "id": "wr-letgo",
    "kind": "phrase",
    "lang": "en",
    "text": "Anyway, I should let you go.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You need to end a phone call politely.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "wr-catchup",
    "kind": "phrase",
    "lang": "en",
    "text": "It was great catching up.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're ending a conversation with someone you haven't seen in a while.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "wr-pickup",
    "kind": "phrase",
    "lang": "en",
    "text": "Let's pick this up again soon.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're ending a conversation but want to continue it later.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "wr-backtoit",
    "kind": "phrase",
    "lang": "en",
    "text": "I'll let you get back to it.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You notice the other person is busy and want to end the chat considerately.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "wr-wraps",
    "kind": "phrase",
    "lang": "en",
    "text": "Well, that about wraps it up.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're closing out a meeting or discussion.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "wr-touchbase",
    "kind": "phrase",
    "lang": "en",
    "text": "Let's touch base again next week.",
    "phonemes": [],
    "category": "wrapup",
    "register": "idiom",
    "scenario": "You're ending a work call and want to schedule a follow-up.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Let's check in with each other again soon."
  },
  {
    "id": "wr-takecare",
    "kind": "phrase",
    "lang": "en",
    "text": "Take care, and talk soon.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're saying goodbye to a friend.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "wr-onthatnote",
    "kind": "phrase",
    "lang": "en",
    "text": "On that note, I'll wrap up.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're finishing a presentation or a long point you were making.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    }
  },
  {
    "id": "sv-sm-lage",
    "kind": "phrase",
    "lang": "sv",
    "text": "Hur är läget?",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You bump into a friend and want to casually ask how they're doing.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "How's it going? / What's up?"
  },
  {
    "id": "sv-sm-lange",
    "kind": "phrase",
    "lang": "sv",
    "text": "Länge sen sist!",
    "phonemes": [],
    "category": "smalltalk",
    "register": "idiom",
    "scenario": "You run into an old friend you haven't seen in ages.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Long time no see!"
  },
  {
    "id": "sv-sm-haft",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vad har du haft för dig?",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You're catching up with someone after a while apart.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "What have you been up to?"
  },
  {
    "id": "sv-sm-varld",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vilken liten värld!",
    "phonemes": [],
    "category": "smalltalk",
    "register": "idiom",
    "scenario": "You discover an unexpected shared connection.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Small world!"
  },
  {
    "id": "sv-sm-kanner",
    "kind": "phrase",
    "lang": "sv",
    "text": "Hur känner ni varandra?",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You're introduced to someone alongside a mutual friend.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "How do you two know each other?"
  },
  {
    "id": "sv-sm-vader",
    "kind": "phrase",
    "lang": "sv",
    "text": "Sjukt väder, va?",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You're making small talk while waiting in line.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Crazy weather, huh?"
  },
  {
    "id": "sv-sm-fixat",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vad fint du har fixat till det!",
    "phonemes": [],
    "category": "smalltalk",
    "register": "connector",
    "scenario": "You walk into a friend's newly decorated home.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "You've made this place so nice!"
  },
  {
    "id": "sv-sm-is",
    "kind": "phrase",
    "lang": "sv",
    "text": "Nu bryter vi isen.",
    "phonemes": [],
    "category": "smalltalk",
    "register": "idiom",
    "scenario": "You're the host and the room's gone quiet.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Let's break the ice."
  },
  {
    "id": "sv-ag-haller",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag håller helt med.",
    "phonemes": [],
    "category": "agree",
    "register": "connector",
    "scenario": "A colleague states an opinion you fully share.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I completely agree."
  },
  {
    "id": "sv-ag-finger",
    "kind": "phrase",
    "lang": "sv",
    "text": "Du satte fingret på det.",
    "phonemes": [],
    "category": "agree",
    "register": "idiom",
    "scenario": "Someone just summarized the problem perfectly.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "You put your finger on it — you hit the nail on the head."
  },
  {
    "id": "sv-ag-precis",
    "kind": "phrase",
    "lang": "sv",
    "text": "Det var precis vad jag tänkte.",
    "phonemes": [],
    "category": "agree",
    "register": "connector",
    "scenario": "Someone voices the same idea you had in mind.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "That's exactly what I was thinking."
  },
  {
    "id": "sv-ag-absolut",
    "kind": "phrase",
    "lang": "sv",
    "text": "Absolut, utan tvekan.",
    "phonemes": [],
    "category": "agree",
    "register": "connector",
    "scenario": "You're asked to confirm you're on board with a plan.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Absolutely, without a doubt."
  },
  {
    "id": "sv-ag-tankar",
    "kind": "phrase",
    "lang": "sv",
    "text": "Du läste mina tankar.",
    "phonemes": [],
    "category": "agree",
    "register": "idiom",
    "scenario": "A friend suggests the exact plan you were about to propose.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "You read my mind."
  },
  {
    "id": "sv-ag-med",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag är helt med dig på det.",
    "phonemes": [],
    "category": "agree",
    "register": "connector",
    "scenario": "A friend shares a strong opinion and you want to back them up.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I'm totally with you on that."
  },
  {
    "id": "sv-ag-vaglangd",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vi är visst på samma våglängd.",
    "phonemes": [],
    "category": "agree",
    "register": "idiom",
    "scenario": "You want to confirm alignment before a project kicks off.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "We're on the same wavelength — same page."
  },
  {
    "id": "sv-ag-saga",
    "kind": "phrase",
    "lang": "sv",
    "text": "Det går inte att säga emot.",
    "phonemes": [],
    "category": "agree",
    "register": "idiom",
    "scenario": "Someone makes a logical point that settles the debate.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Can't argue with that."
  },
  {
    "id": "sv-dis-annorlunda",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag ser det lite annorlunda.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "You want to push back on a colleague's proposal without shutting it down.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I see it a bit differently."
  },
  {
    "id": "sv-dis-saker",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag är inte helt säker på det.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "Someone states something confidently that you doubt.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I'm not entirely sure about that."
  },
  {
    "id": "sv-dis-respekt",
    "kind": "phrase",
    "lang": "sv",
    "text": "Med all respekt, jag tror det finns ett annat sätt att se på det.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "You disagree with someone more senior in a meeting.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "With all respect, I think there's another way to see it."
  },
  {
    "id": "sv-dis-braman",
    "kind": "phrase",
    "lang": "sv",
    "text": "Bra poäng, men…",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "You want to acknowledge someone's argument before disagreeing.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Good point, but…"
  },
  {
    "id": "sv-dis-forstar",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag förstår vad du menar, men jag skulle vilja invända lite.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "A friend makes a claim you want to gently challenge.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I understand what you mean, but I'd like to push back a little."
  },
  {
    "id": "sv-dis-oense",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vi får väl vara oense då.",
    "phonemes": [],
    "category": "disagree",
    "register": "idiom",
    "scenario": "A debate has gone in circles and isn't resolving.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Let's agree to disagree, then."
  },
  {
    "id": "sv-dis-lutar",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag förstår din poäng, men jag lutar åt andra hållet.",
    "phonemes": [],
    "category": "disagree",
    "register": "connector",
    "scenario": "You want to concede part of an argument while holding your position.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I get your point, but I'm leaning the other way."
  },
  {
    "id": "sv-dis-djavul",
    "kind": "phrase",
    "lang": "sv",
    "text": "Bara för att spela djävulens advokat…",
    "phonemes": [],
    "category": "disagree",
    "register": "idiom",
    "scenario": "You want to challenge the group's consensus constructively.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Just to play devil's advocate…"
  },
  {
    "id": "sv-sof-arligt",
    "kind": "phrase",
    "lang": "sv",
    "text": "Ärligt talat tycker jag…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "A friend asks what you really think of their plan.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Honestly, I think…"
  },
  {
    "id": "sv-sof-grej",
    "kind": "phrase",
    "lang": "sv",
    "text": "Om jag ska vara ärlig, det är inte riktigt min grej.",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "Someone asks if you liked a gift or gesture you didn't love.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "If I'm honest, it's not really my thing."
  },
  {
    "id": "sv-sof-fel",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag kan ha fel, men…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "You want to offer a correction without sounding harsh.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I could be wrong, but…"
  },
  {
    "id": "sv-sof-salt",
    "kind": "phrase",
    "lang": "sv",
    "text": "Ta det här med en nypa salt, men…",
    "phonemes": [],
    "category": "soften",
    "register": "idiom",
    "scenario": "You're sharing a rumor or an unverified opinion.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Take this with a pinch of salt, but…"
  },
  {
    "id": "sv-sof-illa",
    "kind": "phrase",
    "lang": "sv",
    "text": "Inte illa menat, men…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "You're about to say something that could sound critical.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "No offense, but…"
  },
  {
    "id": "sv-sof-tvaore",
    "kind": "phrase",
    "lang": "sv",
    "text": "Det är bara mina två öre.",
    "phonemes": [],
    "category": "soften",
    "register": "idiom",
    "scenario": "You've given advice and want to lower the stakes of it.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "It's just my two cents."
  },
  {
    "id": "sv-sof-missuppfattat",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag kan ha missuppfattat det här, men…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "You're raising a concern you're not fully confident about.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I might have misunderstood this, but…"
  },
  {
    "id": "sv-sof-ratta",
    "kind": "phrase",
    "lang": "sv",
    "text": "Rätta mig om jag har fel…",
    "phonemes": [],
    "category": "soften",
    "register": "connector",
    "scenario": "You want to state something while inviting pushback.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Correct me if I'm wrong…"
  },
  {
    "id": "sv-re-jobbigt",
    "kind": "phrase",
    "lang": "sv",
    "text": "Så jobbigt, jag är ledsen.",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "A friend tells you about a bad day at work.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "That's rough, I'm sorry."
  },
  {
    "id": "sv-re-sager",
    "kind": "phrase",
    "lang": "sv",
    "text": "Nej men vad säger du!",
    "phonemes": [],
    "category": "react",
    "register": "idiom",
    "scenario": "Someone shares surprising or shocking news.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "No way! (lit. \"no but what are you saying!\")"
  },
  {
    "id": "sv-re-ana",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag kan bara ana hur det känns.",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "A friend describes a difficult, unfamiliar situation.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I can only imagine how that feels."
  },
  {
    "id": "sv-re-tufft",
    "kind": "phrase",
    "lang": "sv",
    "text": "Det måste ha varit tufft.",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "Someone recounts a stressful experience.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "That must have been tough."
  },
  {
    "id": "sv-re-glad",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag är så glad för din skull!",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "A friend shares great news, like a promotion.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I'm so happy for you!"
  },
  {
    "id": "sv-re-skojar",
    "kind": "phrase",
    "lang": "sv",
    "text": "Du skojar!",
    "phonemes": [],
    "category": "react",
    "register": "idiom",
    "scenario": "Someone tells you something hard to believe.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "You're kidding me!"
  },
  {
    "id": "sv-re-rimligt",
    "kind": "phrase",
    "lang": "sv",
    "text": "Det låter helt rimligt.",
    "phonemes": [],
    "category": "react",
    "register": "connector",
    "scenario": "Someone explains their reasoning and you want to validate it.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "That sounds totally reasonable."
  },
  {
    "id": "sv-re-hjarta",
    "kind": "phrase",
    "lang": "sv",
    "text": "Mitt hjärta blöder för dig.",
    "phonemes": [],
    "category": "react",
    "register": "idiom",
    "scenario": "A friend shares sad or difficult news.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "My heart bleeds for you — I feel deep sympathy."
  },
  {
    "id": "sv-cl-igen",
    "kind": "phrase",
    "lang": "sv",
    "text": "Förlåt, kan du säga det igen?",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You missed part of what someone said.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Sorry, can you say that again?"
  },
  {
    "id": "sv-cl-forstatt",
    "kind": "phrase",
    "lang": "sv",
    "text": "Låt mig se om jag förstått rätt…",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You want to repeat back what you understood before responding.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Let me see if I understood correctly…"
  },
  {
    "id": "sv-cl-menar",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vad menar du egentligen med det?",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "Someone uses a term or phrase you're not sure you understood.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "What do you really mean by that?"
  },
  {
    "id": "sv-cl-sekund",
    "kind": "phrase",
    "lang": "sv",
    "text": "Ge mig en sekund att tänka på det.",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You're asked a question and need a moment before answering.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Give me a second to think about that."
  },
  {
    "id": "sv-cl-atrekommer",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag återkommer till dig om det.",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You don't have an answer ready and need time.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I'll get back to you on that."
  },
  {
    "id": "sv-cl-fraga",
    "kind": "phrase",
    "lang": "sv",
    "text": "Bra fråga — låt mig fundera.",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You're asked something unexpected in a meeting.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Good question — let me think."
  },
  {
    "id": "sv-cl-sager",
    "kind": "phrase",
    "lang": "sv",
    "text": "Så det du säger är…",
    "phonemes": [],
    "category": "clarify",
    "register": "connector",
    "scenario": "You want to paraphrase someone's point to confirm you understood.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "So what you're saying is…"
  },
  {
    "id": "sv-cl-blackout",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag får total blackout just nu.",
    "phonemes": [],
    "category": "clarify",
    "register": "idiom",
    "scenario": "You're asked something and momentarily can't recall the answer.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I'm totally blanking right now."
  },
  {
    "id": "sv-tr-vidare",
    "kind": "phrase",
    "lang": "sv",
    "text": "Men nu går vi vidare…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to shift the conversation to a new topic.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "But now let's move on…"
  },
  {
    "id": "sv-tr-paminner",
    "kind": "phrase",
    "lang": "sv",
    "text": "Det påminner mig om…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "Something just said sparked a related thought.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "That reminds me of…"
  },
  {
    "id": "sv-tr-amne",
    "kind": "phrase",
    "lang": "sv",
    "text": "På ett annat ämne…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to bring up something unrelated to what was just discussed.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "On another topic…"
  },
  {
    "id": "sv-tr-apropa",
    "kind": "phrase",
    "lang": "sv",
    "text": "Apropå det…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to connect the next topic to what was just mentioned.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Speaking of which…"
  },
  {
    "id": "sv-tr-glommer",
    "kind": "phrase",
    "lang": "sv",
    "text": "Innan jag glömmer…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You remember something you need to say before it slips your mind.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Before I forget…"
  },
  {
    "id": "sv-tr-inne",
    "kind": "phrase",
    "lang": "sv",
    "text": "Nu när vi ändå är inne på ämnet…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to add something related to the current topic.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Since we're on the subject anyway…"
  },
  {
    "id": "sv-tr-aterga",
    "kind": "phrase",
    "lang": "sv",
    "text": "För att återgå till det du sa tidigare…",
    "phonemes": [],
    "category": "transition",
    "register": "connector",
    "scenario": "You want to return to an earlier point in the conversation.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "To get back to what you said earlier…"
  },
  {
    "id": "sv-tr-senare",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vi tar det där igen senare.",
    "phonemes": [],
    "category": "transition",
    "register": "idiom",
    "scenario": "A tangent comes up mid-discussion and you want to note it for later.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Let's take that again later — circle back."
  },
  {
    "id": "sv-wr-slappa",
    "kind": "phrase",
    "lang": "sv",
    "text": "Nåja, jag ska släppa dig.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You need to end a phone call politely.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Anyway, I should let you go."
  },
  {
    "id": "sv-wr-roligt",
    "kind": "phrase",
    "lang": "sv",
    "text": "Det var jätteroligt att prata igen.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're ending a conversation with someone you haven't seen in a while.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "It was great catching up."
  },
  {
    "id": "sv-wr-hors",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vi hörs snart igen.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're ending a conversation but want to continue it later.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "We'll talk again soon."
  },
  {
    "id": "sv-wr-fortsatta",
    "kind": "phrase",
    "lang": "sv",
    "text": "Jag ska låta dig fortsätta med ditt.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You notice the other person is busy and want to end the chat considerately.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "I'll let you get back to it."
  },
  {
    "id": "sv-wr-klart",
    "kind": "phrase",
    "lang": "sv",
    "text": "Nåväl, då var det klart för idag.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're closing out a meeting or discussion.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Well, that's it for today."
  },
  {
    "id": "sv-wr-nastavecka",
    "kind": "phrase",
    "lang": "sv",
    "text": "Vi hörs av igen nästa vecka.",
    "phonemes": [],
    "category": "wrapup",
    "register": "idiom",
    "scenario": "You're ending a work call and want to schedule a follow-up.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Let's touch base again next week."
  },
  {
    "id": "sv-wr-tahand",
    "kind": "phrase",
    "lang": "sv",
    "text": "Ta hand om dig, vi hörs.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're saying goodbye to a friend.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "Take care, talk soon."
  },
  {
    "id": "sv-wr-avslutar",
    "kind": "phrase",
    "lang": "sv",
    "text": "Med det sagt avslutar jag här.",
    "phonemes": [],
    "category": "wrapup",
    "register": "connector",
    "scenario": "You're finishing a presentation or a long point you were making.",
    "targetWpm": {
      "slow": 130,
      "steady": 130,
      "fast": 130
    },
    "meaning": "With that said, I'll wrap up here."
  }
];
